import {GoogleMap, InfoWindowF, MarkerF, useLoadScript} from '@react-google-maps/api';
import {mapApiKey} from '../../../config';
import React, {useState} from 'react';
import {Spin} from 'antd';
const containerStyle = {
  width: '100%',
  height: '100%',
};

const MapView = (data: {
  lat: number;
  lng: number;
  bid: string;
  mid: string;
  soc: number;
  soh: number;
}) => {
  const {isLoaded, loadError} = useLoadScript({
    googleMapsApiKey: mapApiKey,
  });
  const [map, setMap] = React.useState(null);

  const [showInfo, setShowInfo] = useState(false);

  const onLoad = (map: any) => {
    setMap(map);
  };

  const onUnmount = () => {
    setMap(null);
  };
  if (loadError) {
    return <>ERROR</>;
  }

  return (
    <div style={{height: '500px'}}>
      {isLoaded ? (
        typeof data.lat === 'string' ? (
          <h1 style={{textAlign: 'center', paddingTop: '50px'}}>Location Not Available</h1>
        ) : (
          <GoogleMap
            mapContainerStyle={containerStyle}
            zoom={20}
            center={{lat: data.lat, lng: data.lng}}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
              minZoom: 3,
              restriction: {
                latLngBounds: {
                  north: 85,
                  south: -85,
                  west: -180,
                  east: 180,
                },
              },
            }}
          >
            <MarkerF
              position={{lat: data.lat, lng: data.lng}}
              onMouseOver={() => {
                //console.log('in');
                setShowInfo(true);
              }}
              onMouseOut={() => {
                //console.log('out');
                setShowInfo(false);
              }}
              onClick={() => {
                window.open(`https://www.google.com/maps?q=${data.lat},${data.lng}`, '_blank');
              }}
            >
              {showInfo && (
                <InfoWindowF>
                  <div>
                    <p style={{margin: '0px', color: 'blue', fontWeight: 'bold'}}>
                      BID: {data.bid}
                    </p>
                    <p style={{margin: '0px', color: 'blue', fontWeight: 'bold'}}>
                      MID: {data.mid}
                    </p>
                    <p style={{margin: '0px', color: 'green', fontWeight: 'bold'}}>
                      SOC: {data.soc}
                    </p>
                    <p style={{margin: '0px', color: 'green', fontWeight: 'bold'}}>
                      SOH: {data.soh}
                    </p>
                  </div>
                </InfoWindowF>
              )}
            </MarkerF>
          </GoogleMap>
        )
      ) : (
        <Spin spinning={true} />
      )}
    </div>
  );
};

export default React.memo(MapView);
